import UserLineIcon from "remixicon-react/UserLineIcon";
import StickyNoteLineIcon from "remixicon-react/StickyNoteLineIcon";
import { InfoContainer, Text } from "$components";
import Notes from "$components/Notes";
import EditButton from "../components/EditButton";
import { useStyles } from "../styles";
import { DockyardDetailsLogic } from "../types";

type DockyardContactInfoProps = Pick<
  DockyardDetailsLogic,
  "dockyard" | "canEdit" | "isFullyDisabled" | "handleClickChantier"
>;

export default function DockyardContactInfo({
  dockyard,
  canEdit,
  isFullyDisabled,
  handleClickChantier,
}: DockyardContactInfoProps) {
  const classes = useStyles();

  return (
    <div style={{ flex: 1 }}>
      <InfoContainer
        className={[classes.informationHeader].join(" ")}
        leftHeader={
          <div className={classes.infoHeader}>
            <UserLineIcon />
            <Text type="h3">Informations contact</Text>
          </div>
        }
        rightHeader={
          <EditButton
            onClick={handleClickChantier}
            canEdit={canEdit}
            isFullyDisabled={isFullyDisabled}
          />
        }
      >
        <div className="about">
          <div className="left">
            <table>
              <tbody>
                <tr>
                  <td className="label">Entreprise</td>
                  <td className="data">
                    {(dockyard?.company as any)?.name || ""}
                  </td>
                </tr>
                <tr>
                  <td className="label">Approbateur</td>
                  <td className="data">
                    {(dockyard as any)?.approver
                      ? `${(dockyard as any).approver.firstname || ""} ${
                          (dockyard as any).approver.lastname?.toUpperCase() ||
                          ""
                        }`.trim()
                      : "Non renseigné"}
                  </td>
                </tr>
                <tr>
                  <td className="label">Email approbateur</td>
                  <td className="data">
                    {(dockyard as any)?.approver?.email || ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </InfoContainer>

      <div style={{ marginTop: 18 }} />

      <InfoContainer
        className={[classes.informationHeader].join(" ")}
        leftHeader={
          <div className={classes.infoHeader}>
            <StickyNoteLineIcon />
            <Text type="h3">Commentaires / notes</Text>
          </div>
        }
        rightHeader={
          <EditButton
            onClick={handleClickChantier}
            canEdit={canEdit}
            isFullyDisabled={isFullyDisabled}
          />
        }
      >
        <Notes text={dockyard?.notes} />
      </InfoContainer>

      <div style={{ marginTop: 18 }} />
    </div>
  );
}
